import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core'
import { Question, QuestionAnswer, QuestionTickerType, QuestionType } from 'src/app/interfaces/question'
import { QUESTION_TITLE_VALUE_REGEX } from 'src/app/services/question/question.service'
import { QuestionImageType } from './../../../interfaces/question'

export interface TitleParseMeta {
  text: string
  regex: RegExp
}

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss'],
})
export class QuestionComponent implements OnInit {
  // common
  @Input() question: Question | undefined
  @Input() titleParseMetaData: TitleParseMeta[] = []
  @Input() showTitle = true
  @Input() disabled = false
  @Output() answered = new EventEmitter<QuestionAnswer>()

  // for linear question
  @Input() checkedOption: number | undefined // 이미 선택된 옵션 (option id)
  @Input() compareOption: number | undefined // 비교 옵션 (option id)
  @Input() isVariedCircleSize = false // 증감 형태의 circle button일 경우
  @Input() otherSideSelectedColor = 'var(--red-30)' // 비교 옵션이 있을 경우, 비교 값과 다른 사이드를 선택 시 컬러
  @Input() imageType: QuestionImageType | undefined
  @Input() tickerSize: 'small' | 'medium' | 'large' = 'large'
  @Input() tickerType: QuestionTickerType = 'default'
  @Input() showTickerToggleIcon = false
  @Input() tickerBackgroundColor: string | undefined

  questionTypeEnum = QuestionType
  parsedQuestion: Question | undefined

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('question') || changes.hasOwnProperty('titleParseMetaData')) {
      this.parsedQuestion = this.parseTitle(this.question, this.titleParseMetaData)
    }
  }

  questionAnswered(data: QuestionAnswer): void {
    this.answered.emit(data)
  }

  private parseTitle(question: Question | undefined, titleParseMetaData: TitleParseMeta[]): Question | undefined {
    if (question === undefined) {
      return
    }
    if (!this.showTitle) {
      return { ...question }
    }

    let { title, description } = question
    titleParseMetaData.forEach((data) => {
      title = title.replace(data.regex, data.text)
      description = description.replace(data.regex, data.text)
    })

    if (title.match(QUESTION_TITLE_VALUE_REGEX)) {
      title = title.replace(QUESTION_TITLE_VALUE_REGEX, '이와 비슷한')
    }
    return { ...question, title, description }
  }
}
